import { Injectable } from '@angular/core';
import Dexie from 'dexie';

@Injectable({
  providedIn: 'root',
})
export class DexieDbService extends Dexie {
  config: Dexie.Table<IConfig, string>;

  constructor() {
    super('Config_DB');
    this.version(1).stores({
      config: 'config_id',
    });
    this.config = this.table('config');
  }

  resetDatabase(): Promise<void> {
    return this.delete();
    // .then(() => {});
  }

  clearTable(): Promise<void> {
    return this.config.clear();
    // .then(() => {})
    // .catch(error => {});
  }

  getAllDataFromMyTable(): Promise<any[]> {
    return this.config.toArray();
  }

  deleteConfig(configId: string) {
    return this.config.where('config_id').equals(configId).delete();
  }

  saveConfig(config_id: string, data: any) {
    return this.config.put({ config_id, data });
  }

  getConfig(configId: string) {
    return this.config.get(configId);
  }
}

interface IConfig {
  config_id: string;
  data: any;
}
